export default "__VITE_ASSET__d3u3dVEc__"